import { Button, Modal } from 'react-bootstrap';
import React from "react";


function C4FInfoModal(props) {
  return (
    <Modal key={props.show}
      show={props.show}
      size={props.size ? props.size : 'm'}
      onHide={() => props.handleClose()} >
      <Modal.Header closeButton>
        <Modal.Title>{props.title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {props.type === 'preformatted' ? 
          <pre>
            {props.info}
          </pre>
          :
          <>{props.info}</>      
      }        
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={() => props.handleClose()}>{'OK'}</Button>
      </Modal.Footer>
    </Modal>

  );
}

export default C4FInfoModal;
